// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h9wX","colBig":"styles_colBig__VjHH3","colSmall":"styles_colSmall__wekt_"};